import { FirebaseAuthentication, SignInResult } from '@capacitor-firebase/authentication'
import { ThirdPartySignInVerifyResponse } from '@eo-storefronts/eo-core'
import useSignInWithAppleVerify from '~/src/hooks/auth/useSignInWithAppleVerify'

interface ReturnsType {
  login(): Promise<ThirdPartySignInVerifyResponse | undefined>,
}

const useLoginWithApple = (): ReturnsType => {
  const { verify: verifyAppleSignInPayload } = useSignInWithAppleVerify()

  const login = async (): Promise<ThirdPartySignInVerifyResponse | undefined> => {
    const signInWithApplePayload: SignInResult = await FirebaseAuthentication.signInWithApple()

    return verifyAppleSignInPayload(signInWithApplePayload)
  }

  return { login }
}

export default useLoginWithApple
